import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class DiagnosticsService {
  apiUrl = environment.apiUrl;

  constructor(readonly http: HttpClient) {}

  getBackendHealthcheck() {
    return this.http.get<any>(`${this.apiUrl}/healthcheck`, { headers: new HttpHeaders().set('X-FC-Noauth', 'true') });
  }
}
